// extracted by mini-css-extract-plugin
module.exports = {"more-button":"LoadMoreBtn_more-button__ntaEc","margin-left-8":"LoadMoreBtn_margin-left-8__Fa9Bs"};